import React, { useContext, useState } from "react";
import AccountPagesHeader from "../components/AccountPagesHeader";
import { Link, useNavigate } from "react-router-dom";
import ErrorAlert from "../admin/components/ErrorAlert";
import { AuthContext } from "../context/auth";

export default function Login() {
  const navigate = useNavigate();
  const { storeTokenInLS } = useContext(AuthContext);

  // State Handling
  const [loginData, setLoginData] = useState({
    user_email: "",
    user_password: "",
  });

  const [loading, setLoading] = useState(false);

  const [error, setError] = useState("");

  const loginSubmitHandle = async (e) => {
    e.preventDefault();
    window.scrollTo(0, 0);
    setLoading(true);
    
    try {
      const response = await fetch(
        "https://hotelbnb-backend.onrender.com/login-verification",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(loginData),
        }
      );

      const result = await response.json();

      if (response.ok) {
        setError("");
        storeTokenInLS(result);
        setLoginData({
          user_email: "",
          user_password: "",
        });
        navigate("/my-account");
      } else if (!response.ok) {
        setError("Login Failed! Email or Password is wrong");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  if (loading)
    return (
      <div className="d-flex flex-column gap-2 justify-content-center align-items-center loading-state">
        <div className="spinner-grow" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p>Logging You In</p>
      </div>
    );

  if (!loading)
    return (
      <>
        {/* Header Start */}
        <AccountPagesHeader status="Logging in to the account" />
        {/* Header End */}

        {/* Showing Alert based on http request response Start */}
        <div className="container-fluid p-0">
          <div className="row app-container mt-3">
            {error && <ErrorAlert errorMsg={error} />}
          </div>
        </div>
        {/* Showing Alert based on http request response End */}

        {/* Login Form Start */}
        <div className="container-fluid login-form-section">
          <div className="row justify-content-center">
            <div className="col-auto p-0 login-form-cover">
              <form method="post" onSubmit={loginSubmitHandle}>
                <div className="form-field">
                  <input
                    type="email"
                    className="form-control"
                    name="user_email"
                    placeholder="Email"
                    required
                    value={loginData.user_email}
                    onChange={(e) => {
                      setLoginData({
                        ...loginData,
                        user_email: e.target.value,
                      });
                    }}
                  />
                </div>
                <div className="form-field">
                  <input
                    type="password"
                    className="form-control"
                    name="user_password"
                    placeholder="Password"
                    required
                    value={loginData.user_password}
                    onChange={(e) => {
                      setLoginData({
                        ...loginData,
                        user_password: e.target.value,
                      });
                    }}
                  />
                </div>
                <button
                  type="submit"
                  className="btn custom-btn login-btn rounded-pill w-100"
                >
                  Login
                </button>
              </form>
              <Link
                to="/create-account"
                className="d-block text-center text-decoration-none signup-link"
              >
                Don't have an account? Sign up
              </Link>
            </div>
          </div>
        </div>
        {/* Login Form End */}
      </>
    );
}
